<template>
  <div>
    <header-applis titre="Connaître votre projet" sous-titre="Vous êtes salarié de droit privé" index-progression-courante="1"/>
    <div class="wrapper__content">
      <ul>
        <li>
          <p>Pour échanger sur votre projet, votre contact est votre opérateur Conseil en Évolution Professionnelle (CEP) : <a href="https://www.mon-cep.org/" target="_blank">www.mon-cep.org</a>
          </p>
          <ul>
            <li>Vous pouvez aussi vous renseigner auprès de votre référent formation ou de votre référent en ressources humaines pour échanger à propos de votre projet</li>
          </ul>
        </li>
        <li>
          <p>Une fois votre orientation finalisée, nous vous invitons à reprendre la démarche engagée, nous pourrons alors donner suite à votre demande.</p>
        </li>
      </ul>
      <envoyer-recapitulatif/>
    </div>
    <footer-applis ecran-precedent="choixstatut"/>
  </div>
</template>

<script>
import EnvoyerRecapitulatif from '../../components/EnvoyerRecapitulatif';
import HeaderApplis from '../../components/HeaderApplis';
import FooterApplis from '../../components/FooterApplis';

export default {
  name: 'salariedroitprive',
  components: {
    FooterApplis,
    HeaderApplis,
    EnvoyerRecapitulatif
  }
}
</script>
